module.exports = new __parcel__URL__("magical-mystery-tour.b3fa66f3.jpg").toString();